<div class="p-3">
  <div class="d-flex gap-3 mb-2">
    <div class="d-flex align-items-center gap-1 text-muted text-sm text-semi-bold flex-1 text-uppercase">
      <ng-container i18n>Automatic Recharge Setting</ng-container>
      <app-page-help articleId="9tvfav7kag"></app-page-help>
    </div>
    <div class="d-flex align-items-center gap-1 text-muted text-sm text-semi-bold flex-1">
      <ng-container i18n>TOP-UP</ng-container>
      <app-page-help articleId="9tvfav7kag"></app-page-help>
    </div>
  </div>
  <div class="d-flex gap-3">
    <div class="card shadow p-3 flex-1 bg-default2">
      <form [formGroup]="settingsForm">
        <div>
          <label for="" class="form-field-label mb-0"
            ><ng-container i18n>Refill Amount($)</ng-container> <sup class="text-danger">*</sup></label
          >
          <div class="text-muted text-sm" i18n>
            Specify the amount for topping up when your balance falls below the minimum.
          </div>
          <mat-form-field2
            matTooltip="Your balance will be recharged when you hit this amount"
            i18n-matTooltip
            [showLabel]="false"
            class="mt-3"
          >
            <input
              type="number"
              matInput
              formControlName="recharge_threshold"
              i18n-placeholder
              placeholder="Refill Amount($)"
            />
            <span matSuffix>USD</span>
            <mat-hint i18n>Example: If set to $10, auto-recharge will trigger when the balance reaches $10</mat-hint>
            <mat-error
              *ngIf="
                settingsForm.get('recharge_threshold').hasError('required') &&
                settingsForm.get('recharge_threshold').touched
              "
            >
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
            <mat-error *ngIf="settingsForm.get('recharge_threshold').hasError('positive')">
              <ng-container i18n>Value should be greater then 0</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="mt-5">
          <label for="" class="form-field-label mb-0"
            ><ng-container i18n>Minimum Balance($)</ng-container> <sup class="text-danger">*</sup></label
          >
          <div class="text-muted text-sm" i18n>Specify the minimum balance for Low balance recharge.</div>

          <mat-form-field2
            matTooltip="This amount will be your actual credit/balance after recharge"
            i18n-matTooltip
            [showLabel]="false"
            class="mt-3"
          >
            <input
              type="number"
              matInput
              formControlName="recharge_balance"
              i18n-placeholder
              placeholder="Minimum Balance($)"
            />
            <span matSuffix>USD</span>
            <mat-error
              *ngIf="
                settingsForm.get('recharge_balance').hasError('required') &&
                settingsForm.get('recharge_balance').touched
              "
            >
              <ng-container i18n>Value is required</ng-container>
            </mat-error>
            <mat-error *ngIf="settingsForm.get('recharge_balance').hasError('positive')">
              <ng-container i18n>Value should be greater then 0</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
      </form>
      <div class="d-flex mt-3">
        <button class="btn btn-secondary-info ml-auto" (click)="onSave(settingsForm)" [disabled]="isSaving">
          <i class="far fa-spinner fa-spin" *ngIf="isSaving"></i>
          <i class="fa fa-save" *ngIf="!isSaving"></i>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
    </div>
    <div class="card shadow p-3 bg-active2 border-light-info flex-1">
      <form [formGroup]="rechargeForm">
        <div>
          <label for="" class="form-field-label mb-0"
            ><ng-container i18n>Recharge Amount($)</ng-container> <sup class="text-danger">*</sup></label
          >
          <div class="text-muted text-sm" i18n>Add a specific amount instantly to your credit balance.</div>
          <mat-form-field2
            matTooltip="Your balance will be increased immediately"
            i18n-matTooltip
            [showLabel]="false"
            class="mt-3"
          >
            <input
              type="number"
              matInput
              formControlName="recharge_amount"
              placeholder="Recharge Amount($)"
              i18n-placeholder
              required
            />
            <span matSuffix>USD</span>
            <mat-error
              *ngIf="
                rechargeForm.get('recharge_amount').hasError('required') && rechargeForm.get('recharge_amount').touched
              "
              i18n
            >
              Value is required
            </mat-error>
            <mat-error *ngIf="rechargeForm.get('recharge_amount').hasError('positive')" i18n>
              Value should be greater then 0
            </mat-error>
            <mat-error *ngIf="rechargeForm.get('recharge_amount').hasError('min')" i18n>
              Value should be greater than 5
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="d-flex align-items-center gap-3 mt-3">
          <button
            class="btn btn-outline-info"
            [class.active]="rechargeForm.get('recharge_amount').value == 20"
            (click)="rechargeForm.get('recharge_amount').setValue(20)"
          >
            USD 20
          </button>
          <button
            class="btn btn-outline-info"
            [class.active]="rechargeForm.get('recharge_amount').value == 50"
            (click)="rechargeForm.get('recharge_amount').setValue(50)"
          >
            USD 50
          </button>
          <button
            class="btn btn-outline-info"
            [class.active]="rechargeForm.get('recharge_amount').value == 100"
            (click)="rechargeForm.get('recharge_amount').setValue(100)"
          >
            USD 100
          </button>
          <button
            class="btn btn-outline-info"
            [class.active]="rechargeForm.get('recharge_amount').value == 150"
            (click)="rechargeForm.get('recharge_amount').setValue(150)"
          >
            USD 150
          </button>
        </div>
      </form>
      <div class="d-flex mt-auto">
        <button [disabled]="isRecharging" class="btn btn-info" (click)="onCharge(rechargeForm)">
          <i class="far fa-spinner fa-spin" *ngIf="isRecharging"></i>
          <i class="cs-icon cs-icon-dollar-refresh-square" *ngIf="!isRecharging"></i>
          <ng-container i18n>Recharge Now</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
